import { makeStyles } from '@material-ui/core';
import { Button } from 'components/Base';
import BottomNavBar from 'components/Cases/BottomNavBar';
import Forms from 'components/Forms';
import React from 'react';
import { compose } from 'redux-starter-kit';
import { PolicyType } from 'store/modules/Policies/types';
import store from 'store/store';
const { connect, actions } = store;

interface IoIncompleteAndSavedPoliciesProps {
  incompletePolicies: PolicyType[];
  completePolicies: PolicyType[];
  moveToComplete?: Function;
  removeIncompletePolicy: Function;
  removeCompletePolicy: Function;
  setIsImportingPolicies: Function;
}

const useStyles = makeStyles({
  title: {
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '30px'
  },
  subTitle: {
    fontWeight: 500,
    fontSize: '16px'
  }
});

const IoIncompleteAndSavedPolicies = ({
  incompletePolicies,
  completePolicies,
  moveToComplete,
  removeIncompletePolicy,
  removeCompletePolicy,
  setIsImportingPolicies
}: IoIncompleteAndSavedPoliciesProps) => {
  const classes = useStyles();
  return (
    <div style={{ height: '100%', width: '100%' }}>
      {incompletePolicies.length > 0 && (
        <div>
          <h3 className={classes.title}>Incomplete</h3>
          <div className={classes.subTitle}>
            Further action is needed on the following polices where highlighted
          </div>
        </div>
      )}
      {incompletePolicies.map((policy, index) => {
        return (
          <Forms.ManagePolicies.Form
            isIoImport={true}
            isIncomplete={true}
            form={`incompletePolicies-policy-${policy.io_id}`}
            key={`incomplete-policy-${policy.io_id}`}
            initialValues={policy}
            policyIndex={index}
            removeLocalPolicy={() => removeIncompletePolicy(policy)}
            markAsSaved={moveToComplete}
          />
        );
      })}
      {completePolicies.length > 0 && (
        <div>
          <h3 className={classes.title}>Complete</h3>
          <div className={classes.subTitle}>
            The following polices have been added successfully and will be
            reflected in the next steps
          </div>
        </div>
      )}
      {completePolicies.map((policy, index) => {
        return (
          <Forms.ManagePolicies.Form
            isIoImport={true}
            isComplete={true}
            form={`complete-policy-${policy.id}`}
            key={`complete-policy-${policy.id}`}
            initialValues={policy}
            policyIndex={index}
            removeLocalPolicy={() => removeCompletePolicy(policy)}
          />
        );
      })}
      <BottomNavBar
        rightButtons={[
          <Button
            key="Investment policy summary button"
            onClick={() => setIsImportingPolicies(false)}
            type="button"
          >
            Proceed
          </Button>
        ]}
      />
    </div>
  );
};

export default compose(
  connect(null, {
    setIsImportingPolicies: actions.PolicyImportActions.setIsImportingPolicies
  })
)(IoIncompleteAndSavedPolicies);
